/**
 * Copyright 2026 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { css } from 'lit';
import { SHARED_STYLES } from '../shared-css.js';
export const ROADMAP_MILESTONE_CARD_CSS = [
    SHARED_STYLES,
    css `
    .layout {
      display: flex;
    }
    .layout.wrap {
      flex-wrap: wrap;
    }
    .layout.center {
      align-items: center;
    }
    .layout.center-center {
      align-items: center;
      justify-content: center;
    }
    .layout.vertical {
      flex-direction: column;
    }
    :host {
      padding: 16px;
      background: #fff;
      padding: 16px;
      margin-bottom: 16px !important;
      border-radius: 3px;
      margin-right: 8px !important;
      margin-left: 8px !important;
      counter-reset: featurecount;
      margin: 8px;
    }
    sl-icon {
      font-size: 1.4rem;
      color: #366597;
    }
    sl-icon:hover {
      color: #248;
    }
    sl-icon.pushicon {
      cursor: pointer;
    }
    sl-icon-button {
     font-size: 16px;
    }
    .popup-content {
      border: 2px solid #888;
      border-radius: 8px;
      background: #f8f8f8;
      color: black;
      font-size: 12pt;
      padding: 1em;
      width: 14em;
    }
    .chrome_version {
      font-size: 45px;
      margin: 8px 0 16px 0;
      white-space: nowrap;
    }
    .channel_label {
      font-weight: 600;
      text-transform: uppercase;
      font-size: 24px;
      text-align: center;
    }
    .chrome_version .chrome-logo,
    .chrome_version--stable .chrome-logo {
      position: relative;
      width: 45px;
      height: 45px;
      background: url(/static/img/chrome_logo.svg) no-repeat 50% 50%;
      background-size: contain;
      margin-right: 8px;
    }
    .chrome_version--beta .chrome-logo {
      background-image: url(/static/img/chrome_logo.svg);
    }
    .chrome_version--dev .chrome-logo {
      background-image: url(/static/img/chrome_logo.svg);
    }
    .chrome_version--canary .chrome-logo {
      background-image: url(/static/img/chrome_logo_canary.svg);
      background-size: 42px;
    }
    .chrome_version--dev_plus_one .chrome-logo {
      filter: gray;
      -webkit-filter: grayscale(1);
      filter: grayscale(1);
    }
    .chrome-logo .channel-tag {
      position: absolute;
      right: 0;
      top: 50%;
      padding: 1px 2px;
      font-size: 10px;
      font-weight: bold;
      color: white;
      background: var(--sl-color-neutral-900);
    }
    .release {
      padding: 16px;
      background: #fff;
      padding: 16px;
      margin-bottom: 16px !important;
      border-radius: 3px;
      flex: 1 0 0;
      min-width: 300px;
      counter-reset: featurecount;
    }
    .release.no-components .feature_shipping_type {
      display: none;
    }
    .release.no-components .feature_shipping_type + ul {
      margin-top: 0;
    }
    .milestone_info {
      margin-bottom: 8px;
    }
    .milestone_info:nth-of-type(3) {
      border-bottom: 1px solid #e6e6e6;
      padding-bottom: 16px;
    }
    .milestone_info .channel_label {
      font-size: inherit;
      font-weight: 500;
      text-transform: none;
    }
    .no_feature_released {
      color: #737373;
    }
    .features_list {
      margin-top: 32px;
    }
    .features_list ul,
    .features_list ol {
      margin-top: 8px;
      list-style: none;
      padding: 0;
    }
    .features_list li {
      padding: 8px;
      font-weight: 500;
    }
    .features_list li .icon_row {
      flex-shrink: 0;
    }
    .features_list .features_header {
      font-weight: 500;
      text-transform: uppercase;
      margin-bottom: 16px;
    }
    .feature_shipping_type {
      margin-top: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .highlight {
      background: var(--light-accent-color);
    }
    #feature_link {
      width: 100%;
    }
    .sl-skeleton-header-container {
      display: flex;
      width: 100%;
      gap: 10px;
      justify-content: center;
      margin-top: 10px;
    }
    .sl-skeleton-header-container sl-skeleton {
      width: 60%;
    }
    .sl-skeleton-title-container {
      width: 50%;
    }
    .features_list sl-skeleton {
      height: 20px;
      margin: 8px;
    }
    .experiment {
      font-size: 85%;
      padding: 2px 8px;
      background: #fea;
      border-radius: 8px;
    }
  `,
];
